import Form from './form'

export default {
  svg: 'network',
  label: 'If / Then',
  type: 'control',
  action: 'ifthen',
  form: Form
}
